import * as React from 'react'
import { render } from 'react-dom'
// import registerServiceWorker from './registerServiceWorker'
import history from './utils/history'
import './index.scss'
import '$utils/rollbar'
import App from './views'
import { Router } from 'react-router'
import { ErrorBoundary } from '$views/components/ErrorBoundary'
import { ThemeProvider } from '$utils/theme'
import { CookieBanner } from '$views/components/CookieBanner'
import { tagManager } from '$infrastructure/tagManager/tagManager'
import { EventSystem } from '$utils/services/eventSystem/eventSystem'
import { chatClient } from '$infrastructure/cometChat/cometChatClient'
import { getUserIdData } from '$services/user/userIdData/userIdData.service'
import { EventSystemName } from '$utils/services/eventSystem/eventSystemName'
import { localUserIdData } from '$utils/services/saveUserIdDataService/saveUserIdDataService'
import { isUserAuthenticated } from '$services/session/isAuthenticated/isAuthenticated.service'

EventSystem.initialize()

tagManager.initialize()

interface WindowWithNativeProps extends Window {
  ReactNativeWebView?: any
}

const sendNavigateEventToReactNative = (pathname: string) => {
  const windowsWithNativeProps: WindowWithNativeProps = window
  if (windowsWithNativeProps.ReactNativeWebView) {
    windowsWithNativeProps.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: 'navigation',
        url: pathname,
      }),
    )
  }
}

const initializeAndLoginCometChatUser = async () => {
  await chatClient.initialize()

  if (isUserAuthenticated()) {
    const userIdData = await getUserIdData()
    localUserIdData.setUserIdData(userIdData)

    const isUserLogged = await chatClient.getLoggedinUser()
    if (!isUserLogged) {
      const chatResponse = await chatClient.loginUser(userIdData.id)
      if (chatResponse && chatResponse.code === 'ERR_UID_NOT_FOUND') {
        await chatClient.createUser(userIdData.id, userIdData.name)
        await chatClient.loginUser(userIdData.id)
      }
    }

    EventSystem.dispatchAppEvent(EventSystemName.loginChat, '')
  }
}

initializeAndLoginCometChatUser()

const mountPoint = document.getElementById('root') as HTMLElement

renderApp()

function renderApp() {
  history.listen(location => {
    sendNavigateEventToReactNative(location.pathname)
  })

  render(
    <ErrorBoundary>
      <Router history={history}>
        <ThemeProvider>
          <CookieBanner>
            <App />
          </CookieBanner>
        </ThemeProvider>
      </Router>
    </ErrorBoundary>,
    mountPoint,
  )
}

if (module.hot) {
  module.hot.accept('./views', () => renderApp())
}

// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.tsx